function separateText(description) {
  return description.split('\n\n');
}

export default separateText;
